import { BehaviorSubject } from 'rxjs/BehaviorSubject';

export class AsyncBehaviorSubject<T> extends BehaviorSubject<T> {
    constructor(defaultValue: T) {
        super(defaultValue);
    }

    public next(value: T): void {
        setTimeout(() => super.next(value), 0);
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/extensions/rxjs/async.behavior.subject.ts